import React from "react";
import { InputNumber, Container, Header, Content, Grid, Row, Col, Heading, HeadingGroup, InputPicker, IconButton, Stack, Drawer, Toggle, Input, InputGroup, MaskedInput, SelectPicker, Text, Button } from 'rsuite';
import { Table, Column, HeaderCell, Cell, } from 'rsuite-table';
import NavBarComponent from "../components/NavBar";
import PageEndIcon from '@rsuite/icons/PageEnd';
import ExportExcel from "../utils/ExcelBtn";
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import 'rsuite/dist/rsuite.min.css';
import 'rsuite/InputPicker/styles/index.css';

import { GrAscend } from "react-icons/gr";
import { GrDescend } from "react-icons/gr";

const URL_FRONT = process.env.REACT_APP_URL_LOCAL;
const URL_BACK = process.env.REACT_APP_URL_SERVER_BACK;

function numberWithCommas(x) {
    if (typeof x !== "undefined") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    }
    else {
        return 0
    }
}

function toPercent(value) {
    return `${(value * 100).toFixed(0)}%`;
  }

//Business Cockpit - Main view
class BusinessCockpit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataTable: this.getTableData('total_onsite_trips', false, null, null, 0.51, 0.48, 1440),
            sort_by: [
                { label: 'Employees', value: 'employees' },
                { label: 'PKm', value: 'total_onsite_pkm' },
                { label: 'Trips', value: 'total_onsite_trips' },
                { label: 'Modal split (Trips) MIV', value: 'modal_split_trips.MIV' },
                { label: 'Modal split (Trips) LV', value: 'modal_split_trips.LV' },
                { label: 'Modal split (Trips) OV', value: 'modal_split_trips.OV' },
                { label: 'Modal split (PKm) MIV', value: 'modal_split_pkm.MIV' },
                { label: 'Modal split (PKm) LV', value: 'modal_split_pkm.LV' },
                { label: 'Modal split (PKm) OV', value: 'modal_split_pkm.OV' },
                { label: 'Potential new commuters', value: 'potential.new_commuters' },
                { label: 'Potenial new revenue', value: 'potential.new_revenue' },
                { label: 'Last-mile potential', value: 'potential.last_mile' },
                { label: 'Work Time potential', value: 'potential.work_time' },
            ],
            filter_by: this.handleFiltering(),
            current_sort_by: 'total_onsite_trips',
            adoption_rate_green: 0.51,
            adoption_rate_yellow: 0.48,
            abo_cost: 1440,
            options_by: [],
            current_options_by: null,
            current_filter_by: null,
            toggle_trips_pkm: false,
            asc_desc: false,
            documentation: false,
            loading: false
        }
    }

    handleOptions(options){
        fetch(URL_BACK + 'sbb_cockpit/filtering_options/'+options, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then((res) => res.json())
            .then((json) => {
                this.setState({ options_by: json });
                return json;
            })
    }

    handleFiltering() {
        fetch(URL_BACK + 'sbb_cockpit/filtering_options', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then((res) => res.json())
            .then((json) => {
                this.setState({ filter_by: json });
                return json;
            })
    }

    handleDocumentation() {
        this.setState({ documentation: !this.state.documentation })
    }

    getTableData(sort, asc_desc, filter, options, adoption_rate_green, adoption_rate_yellow, abo_cost) {
        filter = filter === null ? 'all' : filter;
        options = options === null ? 'all' : options;

        this.setState({ loading: true });


        fetch(URL_BACK + `sbb_cockpit/list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization":`Bearer ${this.props.idToken}`
            },
            body: JSON.stringify({
				"sort": sort,
                "asc": asc_desc,
                "filter": filter,
                "options": options,
                "adoption_rate_green": adoption_rate_green,
                "adoption_rate_yellow": adoption_rate_yellow,
                "abo_cost": abo_cost,
			})
        })
            .then((res) => res.json())
            .then((json) => {
                this.setState({ dataTable: json, loading: false });
                return json;
            })
    }

    changeToggle(event) {
        this.setState({ toggle_trips_pkm: event });
    }

    changeFilterBy(event){
        console.log(event)
        this.setState({ current_filter_by: event });
        if(event=== null){
            this.setState({ current_options_by: null, options_by: [] });
            this.getTableData(this.state.current_sort_by, this.state.asc_desc, event, event, this.state.adoption_rate_green, this.state.adoption_rate_yellow, this.state.abo_cost);
        }else{
            this.handleOptions(event);
        }
    }

    changeOptions(event){
        console.log(event)
        this.setState({ current_options_by: event });
        if(event!== null){
            this.getTableData(this.state.current_sort_by, this.state.asc_desc, this.state.current_filter_by, event, this.state.adoption_rate_green, this.state.adoption_rate_yellow, this.state.abo_cost);
        }else{
            this.getTableData(this.state.current_sort_by, this.state.asc_desc, event, event, this.state.adoption_rate_green, this.state.adoption_rate_yellow, this.state.abo_cost);
        }
    }

    changeSortBy(event) {
        this.setState({ current_sort_by: event });
        this.getTableData(event, this.state.asc_desc, this.state.current_filter_by, this.state.current_options_by, this.state.adoption_rate_green, this.state.adoption_rate_yellow, this.state.abo_cost);
    }

    changeAscDes() {
        let newValue= !this.state.asc_desc
        this.setState({ asc_desc: newValue });
        this.getTableData(this.state.current_sort_by, newValue, this.state.current_filter_by, this.state.current_options_by, this.state.adoption_rate_green, this.state.adoption_rate_yellow, this.state.abo_cost);
    }
    
    changeAdoptionRateGreen(event){
        this.setState({ adoption_rate_green: Number(event) });
    }

    changeAdoptionRateYellow(event){
        this.setState({ adoption_rate_yellow: Number(event) });
    }

    changeAboCost(event){
        this.setState({ abo_cost: Number(event) });
    }

    changeInput(){
        this.getTableData(this.state.current_sort_by, this.state.asc_desc, this.state.current_filter_by, this.state.current_options_by, this.state.adoption_rate_green, this.state.adoption_rate_yellow, this.state.abo_cost);
    }

    getExcel() {
        var all = [];
        var json = this.state.dataTable;
        if (json?.length !== 0 || json?.length !== 'undefined') {
            for (var i = 0; i < json?.length; i++) {
                all.push({
                    "Site Name": json[i].site_name,
                    "Company Name": json[i].company_name,
                    "Municipality": json[i].municipality,
                    "PLZ": json[i].plz,
                    "Canton": json[i].kanton,
                    "Type of Company": json[i].type,
                    "Employees": json[i].employees,
                    "PKm": json[i].total_onsite_pkm,
                    "Trips": json[i].total_onsite_trips,
                    "Modal Split Trips - MIV": json[i].modal_split_trips.MIV.mean,
                    "Modal Split Trips - LV": json[i].modal_split_trips.LV.mean,
                    "Modal Split Trips - ÖV": json[i].modal_split_trips.OV.mean,
                    "Modal Split PKm - MIV": json[i].modal_split_pkm.MIV.mean,
                    "Modal Split PKm - LV": json[i].modal_split_pkm.LV.mean,
                    "Modal Split PKm - ÖV": json[i].modal_split_pkm.OV.mean,
                    "ÖV Quality - Green": (json[i].ov_quality?.green*100)+"%",
                    "ÖV Quality - Yellow": (json[i].ov_quality?.yellow*100)+"%",
                    "ÖV Quality - Red": (json[i].ov_quality?.red*100)+"%",
                    "Confidence": json[i].confidence,
                    "Growth Potential - Green": (json[i].potentia?.behavior*100)+"%",
                    "Growth Potential - Yellow": (json[i].potential?.behavior_yellow*100)+"%",
                    "Potential - Last Mile": (json[i].potential?.last_mile*100)+"%",
                    "Potential - Work Time": (json[i].potential?.working*100)+"%",
                    "Potential New Commuters": (json[i].potential?.new_commuters),
                    "Potential New Revenue (CHF)": (json[i].potential?.new_revenue)
                })
            }
        }

        return all;
    }

    render() {
        const ExcelExportData = this.getExcel();

        let { toggle_trips_pkm } = this.state;

        // const data = {
        //     datasets: [
        //         {
        //             label: "Good",
        //             data: [
        //                 { x: 2, y: 3, r: 2 },
        //                 { x: 3, y: 4, r: 2 },
        //                 { x: 3, y: 5, r: 8 },
        //                 { x: 4, y: 4, r: 2 },
        //                 { x: 4, y: 5, r: 10 },
        //                 { x: 4, y: 6, r: 10 },
        //                 { x: 5, y: 3, r: 2 },
        //                 { x: 5, y: 4, r: 8 },
        //                 { x: 5, y: 5, r: 8 },
        //                 { x: 5, y: 6, r: 24 },
        //                 { x: 5, y: 7, r: 10 },
        //                 { x: 6, y: 4, r: 8 },
        //                 { x: 6, y: 5, r: 8 },
        //                 { x: 6, y: 6, r: 10 },
        //                 { x: 6, y: 7, r: 24 },
        //                 { x: 6, y: 8, r: 10 },
        //                 { x: 7, y: 7, r: 8 },
        //                 { x: 8, y: 7, r: 8 }
        //             ],
        //             borderColor: '#CA0000',
        //             backgroundColor: '#e99494'
        //         },
        //         {
        //             label: "Decent",
        //             data: [
        //                 { x: 1, y: 3, r: 2 },
        //                 { x: 3, y: 4, r: 2 },
        //                 { x: 3, y: 3, r: 8 },
        //                 { x: 2, y: 4, r: 2 },
        //                 { x: 3, y: 5, r: 10 },
        //                 { x: 4, y: 6, r: 10 },
        //                 { x: 5, y: 3, r: 2 },
        //                 { x: 1, y: 4, r: 8 },
        //                 { x: 5, y: 5, r: 8 },
        //                 { x: 3, y: 6, r: 24 },
        //                 { x: 5, y: 7, r: 10 },
        //                 { x: 8, y: 4, r: 8 },
        //                 { x: 6, y: 9, r: 8 },
        //                 { x: 6, y: 6, r: 10 },
        //                 { x: 6, y: 7, r: 24 },
        //                 { x: 5, y: 3, r: 10 },
        //                 { x: 7, y: 1, r: 8 },
        //                 { x: 8, y: 1, r: 8 }
        //             ],
        //             borderColor: '#FB9013',
        //             backgroundColor: '#fad4b3'
        //         },
        //         {
        //             label: "Bad",
        //             data: [
        //                 { x: 4, y: 3, r: 2 },
        //                 { x: 3, y: 4, r: 2 },
        //                 { x: 3, y: 5, r: 8 },
        //                 { x: 2, y: 1, r: 5 },
        //                 { x: 4, y: 1, r: 10 },
        //                 { x: 8, y: 6, r: 10 },
        //                 { x: 5, y: 3, r: 2 },
        //                 { x: 6, y: 4, r: 8 },
        //                 { x: 5, y: 6, r: 8 },
        //                 { x: 5, y: 6, r: 24 },
        //                 { x: 5, y: 2, r: 10 },
        //                 { x: 6, y: 1, r: 8 },
        //                 { x: 6, y: 2, r: 8 },
        //                 { x: 6, y: 3, r: 10 },
        //                 { x: 6, y: 6, r: 10 },
        //                 { x: 7, y: 5, r: 8 }
        //             ],
        //             borderColor: '#2DAD00',
        //             backgroundColor: '#b4eda0'
        //         }
        //     ]
        // };

        // const options = {
        //     aspectRatio: 1,
        //     elements: {
        //         bubble: {
        //             label: "xxx"
        //         },
        //         point: {

        //         }
        //     },
        //     scales: {
        //         x: {
        //             display: true,
        //             title: {
        //                 display: true,
        //                 text: 'Modal Split (%)',
        //                 padding: { top: 20, left: 0, right: 0, bottom: 0 }
        //             }
        //         },
        //         y: {
        //             display: true,
        //             title: {
        //                 display: true,
        //                 text: 'Upsell Potential (CHF)',
        //                 padding: { top: 30, left: 0, right: 0, bottom: 0 }
        //             }
        //         }
        //     },
        //     plugins: {
        //         legend: {
        //             position: 'bottom',
        //         },
        //         title: {
        //             display: true,
        //             text: 'Overview'
        //         }
        //     }
        // };

        return (
            <>
                <Drawer placement={'right'} open={this.state.documentation} size={'md'} onClose={() => this.handleDocumentation()}>
                    <Drawer.Header>
                        <Drawer.Title>SBB Cockpit</Drawer.Title>
                    </Drawer.Header>

                    <Drawer.Body>
                        <Text>The SBB Business cockpit by 42hacks provides  SBB Teams with company site level mobility data analysis. The main menu provides a list of all company sites with key data, and options to sort and filter companies. </Text>
                        <Heading level={4} style={{ paddingTop: '10px' }}>Sort by</Heading>
                        <img src={require('../assets/img/sorting.jpg')} style={{ width: '100%', paddingTop: '5px', paddingBottom: '5px' }}></img>
                        <Text>Companies can be sorted by: </Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Daily PKm:</span> The total amount of kilometers that all commuters to the company site travel per day.</Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Trips:</span> The total amount of daily commuter trips to the company site.</Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Modal Split</span> shows which modes of transport commuters use. Modal split can be filtered by the percentage of MIV (Motorisierter Individualverkehr), LV (Langsamverkehr, including walking and cycling) and ÖV (Public transport.). Modal Split (Trips) displays the percentage of daily trips for each mode of transport, while Modal Split (PKm) shows the percentage of total daily passenger kilometers.</Text>
                        <Heading level={4} style={{ paddingTop: '10px' }}>Filter by</Heading>
                        <img src={require('../assets/img/filter.jpg')} style={{ width: '100%', paddingTop: '5px', paddingBottom: '5px' }}></img>
                        <Text>- Sales Region filters company sites by SBB Sales regions.</Text>
                        <Text>- Company groups company sites, allowing a quick overview of how the multiple sites of a company compare.</Text>
                        <Text>- Location, allows to filer company according to their location type, including isolated, industrial zone, urban, or near the border.</Text>
                        <Text>- Tarif Zone Region filters company sites according to the corresponding tarif zone.</Text>
                        <Heading level={4} style={{ paddingTop: '10px' }}>Modal Split Toogle</Heading>
                        <img src={require('../assets/img/toggle.jpg')} style={{ width: '100%', paddingTop: '5px', paddingBottom: '5px' }}></img>
                        <Text>The Modal Split toogle allows users to switch between modal split calculations based on the total daily amount of passenger kilometers (PKm), or the total amount of daily commuter trips (trips). The values in the main list, change accordingly. <span style={{ fontStyle: 'italic' }}>Note: The confidence range also changes for trips or PKm based modal split.</span></Text>
                        <Heading level={4} style={{ paddingTop: '10px' }}>Download Excel</Heading>
                        <Text>The download button generates a downloadable excel version of the main view. <span style={{ fontStyle: 'italic' }}>Note: The Excel contain both trip based and PKm based modal split calculations, independently of the toogle setting.</span></Text>
                        <Heading level={4} style={{ paddingTop: '10px' }}>Columns</Heading>
                        <img src={require('../assets/img/Columns.jpg')} style={{ width: '100%', paddingTop: '5px', paddingBottom: '5px' }}></img>
                        <Heading level={5} style={{ paddingTop: '5px' }}>Company Sites</Heading>
                        <Text><span style={{ fontStyle: 'italic' }}>Note: The cockpit is based on company sites. Filtering by company will group all sites within a company and provide company level aggregation.</span></Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Location:</span> The cockpit categorises several company site location types, including isolated, industrial zone, urban, or near the border. Generally speaking, the modal split data will be more accurate for companies that are isolated, or that generate a lot of traffic compared to their surroundings. </Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Employees:</span> The number of employees per company site is drawn from the Swiss Federal Statistical Office's <a href="https://www.bfs.admin.ch/bfs/en/home/services/geostat/swiss-federal-statistics-geodata/business-employment/structural-business-statistics-statent-from-2011-onwards.html">[Structural business statistics]</a>. The register that maps business locations and data is regularly updated. </Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>PKm:</span> PKm displays the total number of person kilometres that commuters travel to the company site.</Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Commuters:</span> Shows how many commuters travel to the company site per day. <span style={{ fontStyle: 'italic' }}>Note: this number differs from the total number of employees because not all employees go to work every day. You can find more info on how the cockpit estimates how many people come to work per day in the company site detail view</span></Text>
                        <Heading level={5} style={{ paddingTop: '5px' }}>Modal Split</Heading>
                        <img src={require('../assets/img/modal split.jpg')} style={{ width: '100%', paddingTop: '5px', paddingBottom: '5px' }}></img>
                        <Text>Modal Split shows the percentage of commuters per kind of transport. The cockpit provides modal split calculations for MIV (Motorisierter Individualverkehr), LV (Langsamverkehr, including walking and cycling) and ÖV (Public transport.). Depending on the <span style={{ fontWeight: 'bold' }}>Modal Split Toogle</span> setting, the column displays the percentage of daily trips for each mode of transport, or the percentage of total daily passenger kilometers. The  <span style={{ fontWeight: 'bold' }}>main percentage</span> (highlighted in green) displays the estimated modal split. </Text>
                        <Heading level={6} style={{ paddingTop: '5px' }}>Confidence Range</Heading>
                        <Text>The smaller percentage (highlighted in red) shows the confidence range. <span style={{ fontWeight: 'bold' }}>Confidence range</span> indicates how much the displayed modal split calculation might differ. In the example, we see a PKm based LV modal split of 2%, and a confidence range of ±0.28. This means that the modal split should range between 1.72 (2-0.28) and 2.28. The smaller the confidence range, the more accurate the modal split calculation. The confidence range depends on how difficult it is to isolate the commuter trips for a specific company location from other trips in the neighborhood. As a rule of thumb the confidence range will be smaller (which means better accuracy) if the company site is relatively isolated, or if the company site generates a lot of traffic compared to the overall traffic in the neighborhood. </Text>
                        <Text><span style={{ fontWeight: 'bold' }}>Precision</span> indgives a rough indication of modal split accuracy, sorting company sites in sites with 'high.' 'good,' or 'basic' data accuracy. Precision is based on the lowest confidence range for the MIV, LV and ÖV Modal Split.</Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>High precision:</span> The lowest confidence range is below 10%</Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Good precision:</span> The lowest confidence range is between 10 and 20%</Text>
                        <Text>- <span style={{ fontWeight: 'bold' }}>Basic precision:</span> The confidence range is above 20%</Text>

                        <Heading level={4} style={{ paddingTop: '10px' }}>Details</Heading>
                        <Text>Opens a detailed view for the selected company site.</Text>
                    </Drawer.Body>
                </Drawer>
                <Container style={{ height: '100vh', overflow: 'hidden' }}>
                    {/* Background */}
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: '#f7f7fa',
                            zIndex: -1, // Keep it behind everything
                        }}
                    ></div>

                    <Container style={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
                        {/* Header */}
                        <Header className="page-header">
                            <NavBarComponent />
                        </Header>

                        {/* Content */}
                        <Content style={{ height: 'calc(100% - 60px)', overflow: 'hidden' }}>
                            <Grid fluid style={{ height: '100%' }}>
                                <Row style={{ height: '100%' }}>
                                    {/* Gray Column
                    <Col
                        xs={24} md={8}
                        style={{
                            backgroundColor: '#f7f7fa',
                            padding: '15px',
                            height: '100%', // Constrain the height
                            overflowY: 'auto', // Make this column scrollable if necessary
                        }}
                    >
                        <Bubble data={data} options={options} />
                    </Col> */}

                                    {/* White Column */}
                                    <Col
                                        xs={24} md={24}
                                        style={{
                                            backgroundColor: 'white',
                                            padding: '15px',
                                            height: '100%',
                                            overflowY: 'auto', // Enable scrolling here
                                        }}
                                    >
                                        <Row style={{ paddingTop: '15px' }}>
                                            <Col align='left' xs={24} md={18}>
                                                <Heading level={1}>SBB Cockpit: Top Business Accounts</Heading>
                                            </Col>
                                            <Col align='right' xs={24} md={6}>
                                                <IconButton icon={<InfoOutlineIcon />}
                                                    // onClick={() => this.handleDocumentation()} 
                                                    onClick={() => window.open('https://42hacks.notion.site/User-Guide-Company-Mobility-Intel-19763b82658180f3b6f2df356d348f85', "_blank", "noreferrer")}
                                                >
                                                    Help
                                                </IconButton>                                        </Col>
                                        </Row>
                                        <HeadingGroup style={{ padding: '15px 0' }} align='left'>
                                            <Heading level={4}>{this.state.dataTable?.length} Company Sites</Heading>
                                        </HeadingGroup>

                                        <Stack  direction={'row'} justifyContent={'space-between'} wrap style={{ paddingBottom: '15px' }}>

                                            <div>
                                            <SelectPicker style={{ width: 250 }} cleanable={false} searchable={false} data={this.state.sort_by} defaultValue={this.state.current_sort_by} onChange={this.changeSortBy.bind(this)} label="Sort by" />
                                            { this.state.asc_desc === true ?
                                            <IconButton icon={<GrDescend />} onClick={this.changeAscDes.bind(this)}/>
                                            :
                                            <IconButton icon={<GrAscend/>} onClick={this.changeAscDes.bind(this)}/>
                                            }
                                            </div>
                                            <div>
                                            <SelectPicker style={{ width: 250 }} cleanable={true} searchable={false} data={this.state.filter_by} defaultValue={this.state.current_filter_by} onChange={this.changeFilterBy.bind(this)} label="Filter by" />
                                            <SelectPicker style={{ width: 250 }} cleanable={true} searchable={true} disabled={this.state.current_filter_by===null} data={this.state.options_by} defaultValue={this.state.current_options_by} onChange={this.changeOptions.bind(this)} placeholder="Search..."/>
                                            </div>
                                            <div>
                                                <Text >Modal Split based on: </Text> <Toggle color="violet" checkedChildren="PKm" unCheckedChildren="Trips" defaultValue={this.state.toggle_trips_pkm} onChange={this.changeToggle.bind(this)} />

                                            </div>


                                            {/* <InputGroup inside style={{ width: 350 }} >
      <InputGroup.Addon>Search: </InputGroup.Addon>
      <Input/>
    </InputGroup> */}


                                        </Stack>

                                        <Stack  direction={'row'} justifyContent={'space-between'} wrap style={{  padding: '10px 10px', background: "rgb(231,233,235)"}}>
                                        <div>
                                        <Text>Adoption rates for Green ÖV-Quality: </Text> 
                                        <InputNumber value={this.state.adoption_rate_green} min={0} max={1} step={0.01} formatter={toPercent} onChange={this.changeAdoptionRateGreen.bind(this)}/>
                                        </div>
                                        <div>
                                        <Text>Adoption rates for Yellow ÖV-Quality: </Text> 
                                        <InputNumber value={this.state.adoption_rate_yellow} min={0} max={1} step={0.01} formatter={toPercent} onChange={this.changeAdoptionRateYellow.bind(this)}/>
                                        </div>
                                        <div>
                                        <Text>Abo Cost:</Text> 
                                        <InputNumber value={this.state.abo_cost} formatter={value => `${value} CHF`} onChange={this.changeAboCost.bind(this)}/>
                                        </div>
                                        
                                        <Button appearance="primary" color="violet"
                                                    onClick={this.changeInput.bind(this)}
                                                >
                                                    Calculate input
                                                </Button>
                                        </Stack>

{/* Download Button */}
<Stack style={{ padding: '25px 0px 25px' }} justifyContent="space-between" direction="row-reverse" spacing={10}>
                                            <ExportExcel excelData={ExcelExportData} fileName={'SBB Business Cockpit - ' + this.state.dataTable?.length + ' companies'} />
                                        </Stack>

                                        {/* Scrollable Table */}
                                        <Table
                                            fillHeight={false}
                                            autoHeight={true}
                                            defaultExpandAllRows={false}
                                            headerHeight={50}
                                            rowHeight={50}
                                            data={this.state.dataTable}
                                            loading={this.state.loading}
                                        >
                                            <Column flexGrow={0.5} minWidth={50} align="left">
                                                <HeaderCell style={{ background: '#F6F6F6', fontSize: '14px', fontWeight: 600, color: '#000000' }}>#</HeaderCell>
                                                <Cell>
                                                    {(rowData, dataIndex) => {
                                                        return <div>{dataIndex + 1}</div>
                                                    }}
                                                </Cell>
                                            </Column>

                                            <Column flexGrow={2} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Company Site<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Address
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }} fullText>
                                                    {(rowData) => {
                                                        return <div>{rowData.company_name} {rowData.site_name}<br />
                                                            <span style={{ fontSize: '10px', textAlign: 'left' }}>{rowData.municipality}, {rowData.plz}, {rowData.kanton}</span></div>;
                                                    }}
                                                </Cell >

                                            </Column>

                                            {/* <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Cluster<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Based on Location
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell dataKey="company_cluster" />
                                            </Column> */}

                                            <Column flexGrow={1} minWidth={150} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Location
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        if (rowData.type.includes("(")) {
                                                            return <div>{rowData.type.split('(')[0]}<br />
                                                                <span style={{ fontSize: '10px', textAlign: 'left' }}>{(rowData.type.split('(')[1]).slice(0, -1)}</span></div>
                                                        }
                                                        else {
                                                            return <div>{rowData.type}</div>
                                                        }
                                                    }}
                                                </Cell >
                                            </Column>


                                            <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Employees<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Based on BFS
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas(rowData.employees)}</div>;
                                                    }}
                                                </Cell >
                                            </Column>


                                            <Column flexGrow={1} minWidth={80} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        {!toggle_trips_pkm ? "Trips" : "PKm"}<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Per Day
                                                        </span>
                                                    </div>
                                                </HeaderCell>

                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return !toggle_trips_pkm ?
                                                            <div>{numberWithCommas(rowData.total_onsite_trips.toFixed(0))}</div>
                                                            :
                                                            <div>{rowData.total_onsite_pkm=== undefined ? '-' : numberWithCommas(rowData.total_onsite_pkm.toFixed(0))}</div>
                                                    }}
                                                </Cell >
                                            </Column>

                                            {/* <Column flexGrow={1} minWidth={80} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Commuters<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Per Day
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas(rowData.total_onsite_trips?.toFixed(0))}</div>;
                                                    }}
                                                </Cell >
                                            </Column> */}


                                            <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Modal Split<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            ÖV
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        let modal_split = 'modal_split_trips'

                                                        !toggle_trips_pkm ? modal_split = 'modal_split_trips' : modal_split = 'modal_split_pkm'

                                                        return <div>{(rowData[modal_split].OV.mean * 100).toFixed(0)}%<br />
                                                            <span style={{ fontSize: '10px', textAlign: 'left' }}>±{(rowData[modal_split].OV.std * 100).toFixed(2)}%</span></div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Modal Split<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            MIV
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        let modal_split = 'modal_split_trips'

                                                        !toggle_trips_pkm ? modal_split = 'modal_split_trips' : modal_split = 'modal_split_pkm'

                                                        return <div>{(rowData[modal_split].MIV.mean * 100).toFixed(0)}%<br />
                                                            <span style={{ fontSize: '10px', textAlign: 'left' }}>±{(rowData[modal_split].MIV.std * 100).toFixed(2)}%</span></div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Modal Split<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            LV
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        let modal_split = 'modal_split_trips'

                                                        !toggle_trips_pkm ? modal_split = 'modal_split_trips' : modal_split = 'modal_split_pkm'

                                                        return <div>{(rowData[modal_split].LV.mean * 100).toFixed(0)}%<br />
                                                            <span style={{ fontSize: '10px', textAlign: 'left' }}>±{(rowData[modal_split].LV.std * 100).toFixed(2)}%</span></div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        ÖV Quality<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Green
                                                        </span>
                                                        </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas((rowData.ov_quality?.green*100).toFixed(0))} %</div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        ÖV Quality<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Yellow
                                                        </span>
                                                        </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas((rowData.ov_quality?.yellow*100).toFixed(0))} %</div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={3} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                    Last-Mile Potential<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                        Green ÖV-quality increase
                                                        </span>
                                                        </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas((rowData.potential?.last_mile*100).toFixed(0))}%</div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={3.5} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                    Working Time Potential<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                        Green ÖV-quality increase
                                                        </span>
                                                        </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas((rowData.potential?.working*100).toFixed(0))}%</div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={3.5} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                    Potential new commuters<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                        Status Quo
                                                        </span>
                                                        </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas((rowData.potential?.new_commuters).toFixed(0))}</div>;
                                                    }}
                                                </Cell >
                                            </Column>

                                            <Column flexGrow={3.5} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                    Potential new revenue<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                        Status Quo (CHF)
                                                        </span>
                                                        </div>
                                                </HeaderCell>
                                                <Cell style={{ alignContent: "center", textAlign: 'left' }}>
                                                    {(rowData) => {
                                                        return <div>{numberWithCommas((rowData.potential?.new_revenue).toFixed(0))}</div>;
                                                    }}
                                                </Cell >
                                            </Column>


                                            {/* <Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        B2B Potential<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            Revenue (CHF)
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{alignContent: "center", textAlign: 'left'}}>
                                                {(rowData) => {
                                            return <div>{numberWithCommas(rowData.revenue)}</div>;
                                        }}
                                                                                        </Cell >
                                            </Column> */}

<Column flexGrow={1} minWidth={100} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Precision
                                                    </div>
                                                </HeaderCell>
                                                <Cell dataKey="confidence" />
                                            </Column>


                                            <Column flexGrow={0.7} minWidth={80} align="left">
                                                <HeaderCell
                                                    style={{
                                                        background: '#F6F6F6',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#000000',
                                                        textAlign: 'left', // Optional: Align content in the center
                                                        lineHeight: '1.2',  // Ensure proper spacing
                                                    }}
                                                >
                                                    <div>
                                                        Details<br />
                                                        <span style={{ fontSize: '10px', fontWeight: 500, display: 'block' }}>
                                                            See more
                                                        </span>
                                                    </div>
                                                </HeaderCell>
                                                <Cell style={{ paddingBottom: 0, paddingTop: 0 }}>
                                                    {rowData => {
                                                        return <IconButton
                                                            appearance="subtle"
                                                            icon={<PageEndIcon />}
                                                            onClick={() => {
                                                                window.open(URL_FRONT + 'b2b/detail/' + rowData.id+'_2023', "_blank", "noreferrer");
                                                            }}
                                                        />

                                                    }
                                                    }
                                                </Cell>
                                            </Column>
                                        </Table>
                                    </Col>
                                </Row>
                            </Grid>
                        </Content>
                    </Container>
                </Container>
            </>
        )
    }
}

export default BusinessCockpit;